var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-part",on:{"click":_vm.to}},[_vm._m(0),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-part__txt"},[_c('span',[_vm._v("了解更多数据动态，请前往")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-part__lasac"},[_c('a',{attrs:{"href":"http://www.sasclouds.com/"}})])
}]

export { render, staticRenderFns }